import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import Conditional from '@app/components/common/Conditional';

const NicknameField = ({ showAddressName, isAddressNameEditable }) => {
  const [t] = useTranslation();
  const { getValues } = useFormContext();

  const nickName = getValues('nickName');

  return (
    <Conditional test={showAddressName}>
      {isAddressNameEditable ? (
        <FormField
          fieldId="nickName"
          required
          label={t('ADDRESS_NAME')}
          maxLength="140"
        />
      ) : (
        <div className="d-flex flex-column gap-2">
          <p className="cat-u-theme-typography-label-sm m-0 text-capitalize">
            {t('ADDRESS_NAME')}
          </p>
          <p className="cat-u-theme-typography-body mb-0">{nickName}</p>
        </div>
      )}
    </Conditional>
  );
};

NicknameField.propTypes = {
  showAddressName: PropTypes.bool,
  isAddressNameEditable: PropTypes.bool
};

export default NicknameField;
